// extracted by mini-css-extract-plugin
module.exports = {"swapContainer":"lq_fwL","subHeader":"_9Go8vn","header":"NJn3PM","container":"hBccsB","img":"F1GgNL"};